import React from 'react';
import {MdTextField, MdCheckbox} from 'core/components/fields/fields';
import {createForm} from 'core/form/createForm';
import StyledSelect from 'core/components/fields/styledSelect';
import {Validate} from 'core/form/validate';
import JobService from "core/job/jobService";
import {valid, invalid, PrimaryKeyString} from 'core/form/rules';
import {observer} from "mobx-react";
import {FormProps} from "core/form/formUtils";
import {TriggerInfo, JobInfo} from "core/job/jobDomain";
import {DefinitionType, FIELDDEFDISPLAYTYPE} from "core/form/form";


function TriggerExists({value, name}: {value: string, name: string}) : any {
  if (!value) return valid();
  if (name == value) return valid();
  return JobService.triggerExist(value)
    .then( (exists) => (exists) ? invalid(`Trigger ${value} already exists`) : valid());
}

function CronCheck({value}) : any {
  if (!value) return valid();
  return JobService.cronCheck(value)
    .then( (errorText) => (errorText) ? invalid(errorText) : valid());
}


@observer
class TriggerForm extends React.Component<FormProps<TriggerInfo, JobInfo>, undefined> {

  render() {

    let {dataObject, rootObject, entities, formName} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {name, cronExpression, misfirePolicy, addHolidayCalendar} = fields;


    console.debug("TriggerForm#render() %O", dataObject);

    return (
      <div className="row">
        <div className="fx col-xs-12 col-sm-6">
          <MdTextField {...name.props} disabled={!dataObject.$new}/>
          <Validate field={name} value={name.props.value}>
            <PrimaryKeyString/>
            <TriggerExists name={dataObject.name}/>
          </Validate>
        </div>
        <div className="fx col-xs-12 col-sm-6">
          <MdTextField {...cronExpression.props} />
          <Validate field={cronExpression} value={cronExpression.props.value} >
            <CronCheck/>
          </Validate>
        </div>
        <div className="fx col-xs-6 col-sm-2">
          <StyledSelect {...misfirePolicy.props} />
          <Validate field={misfirePolicy} value={misfirePolicy.props.value} />
        </div>
        <div className="fx col-xs-6 col-sm-4">
          <MdCheckbox {...addHolidayCalendar.props}/>
        </div>
        <div className="fx col-xs-12 col-sm-6" style={{paddingTop:12, fontSize: 14}}>
          <a href="http://www.quartz-scheduler.org/documentation/quartz-2.3.0/tutorials/crontrigger.html" target="_blank" >Cron Expression Documentation
            <span className="fa fa-external-link zz-ml-5"/>
          </a>
        </div>
      </div>
    );

  }
}


const definition: DefinitionType = {
  formName: 'TriggerForm',
  fields: [{
    name: 'name',
    validators: ['IsRequired']
  }, {
    name: 'cronExpression',
    validators: ['IsRequired']
  }, {
    name: 'misfirePolicy',
    validators: ['IsRequired']
  }, {
    name: 'addHolidayCalendar',
    displayType: FIELDDEFDISPLAYTYPE.checkbox
  }]
};


export default createForm(definition, () => <noscript/>)(TriggerForm);






// WEBPACK FOOTER //
// ./src/core/job/triggerForm.tsx